import React from 'react';
import PropTypes from 'prop-types';

import { Area } from 'components/elements';

// Import stled components
import { TextAreaWrapper, FormError } from './styles';

function TextArea({
	type,
	field,
	name,
	autoComplete,
	form: { touched, errors },
	placeholder,
	disabled,
	marginBottom
}) {
	return (
		<TextAreaWrapper marginBottom={marginBottom}>
			<Area
				className={`${
					touched[field.name] && errors[field.name] ? 'errors' : ''
				}`}
				disabled={disabled}
				type={type}
				name={name}
				autoComplete={autoComplete}
				placeholder={placeholder}
				{...field}
			/>
			{touched[field.name] && errors[field.name] && (
				<FormError>{errors[field.name]}</FormError>
			)}
		</TextAreaWrapper>
	);
}

TextArea.propTypes = {
	type: PropTypes.string,
	name: PropTypes.string,
	autoComplete: PropTypes.string,
	form: PropTypes.shape({
		touched: PropTypes.object,
		errors: PropTypes.object
	}),
	disabled: PropTypes.bool,
	text: PropTypes.string,
	placeholder: PropTypes.string,
	marginBottom: PropTypes.string
};

TextArea.defaultProps = {
	type: 'text',
	name: 'agreement',
	autoComplete: 'true',
	form: { touched: {}, errors: {} },
	placeholder: '',
	disabled: false,
	text: '',
	marginBottom: '1.5'
};

export default TextArea;
